import React from 'react'

import {sum} from 'es-toolkit/compat'

import {mapChildrenWithFragments} from '../../../../commons/src/services/react-children'

import TableCell from './TableCell'

type TableCellProps = {props: React.ComponentProps<typeof TableCell>}

export const getCellLayout = (cells: React.ReactNode) => {
  const widths = mapChildrenWithFragments(cells, ({props: {width = 1}}: TableCellProps) =>
    typeof width === 'string' ? 0 : width
  )
  const aligns = mapChildrenWithFragments(
    cells,
    ({props: {align = 'left'}}: TableCellProps) => align
  ) as ('left' | 'center' | 'right')[]

  const totalWidths = sum(widths)

  const computeWidth = (width: number | string) =>
    typeof width === 'string' ? width : `${(width / totalWidths) * 100}%`

  const computedWidths = mapChildrenWithFragments(cells, ({props: {width = 1}}: TableCellProps) =>
    computeWidth(width)
  ) as string[]

  return {
    aligns,
    computedWidths,
  }
}
